import { view_route,chart_types } from "data/Spec";
import React, { useEffect } from "react";
import { FormattedMessage, useIntl } from "react-intl";
import { Link } from "react-router-dom";

function Top() {
  const intl = useIntl();
  useEffect(() => {
    document.title = intl.formatMessage({ id: "app.top" });
  });

  var viewMenu = [];
  var chartMenu = [];
  var path = ""
  for (let key in view_route) {
    path = "/view/" + key;
    let lkey = "view_" + key
    viewMenu.push(
      <li key={lkey}>
        <Link to={path}>
          <FormattedMessage id={view_route[key]["title_id"]} />
        </Link>
      </li>
    );
  }
  for (let key in chart_types) {
    path = "/chart/" + key;
    let lkey = "chart_" + key
    chartMenu.push(
      <li key={lkey}>
        <Link to={path}>
          <FormattedMessage id={chart_types[key]["title_id"]} />
        </Link>
      </li>
    );
  }
  return (
    <div>
      <header className="App-header">
        <h1>{intl.formatMessage({ id: "app.top" })}</h1>
        {intl.formatMessage({ id: "app.top.disclaimer" })}
      </header>
      <h2>{intl.formatMessage({ id: "app.top.menu1" })}</h2>
      <div>
        <ul className="menu">{viewMenu}</ul>
      </div>
      <h2>{intl.formatMessage({ id: "app.top.menu2" })}</h2>
      <div>
        <ul className="menu">
          {chartMenu}
        </ul>
      </div>
    </div>
  );
}

export default Top;
